import React from 'react';

interface MediaKitEditButtonProps {
    onClick: () => void;
    label: string;
}

export default function MediaKitEditButton({ onClick, label }: MediaKitEditButtonProps) {
    return (
        <button type="button" className="media-kit-section-edit" onClick={onClick} aria-label={label}>
            <svg className="media-kit-section-edit-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path
                    fill="currentColor"
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                />
            </svg>
        </button>
    );
}
